import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { LuImageOff } from "react-icons/lu";
import CarPurchaseModel from "../Models/CarPurchaseModel";
import axios from "axios";

const Url = process.env.REACT_APP_SERVER_URL;
const apiUrl = process.env.REACT_APP_MAIN_URL;

const ShowRoomCards = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [carTitle, setCarTitle] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadedImages, setLoadedImages] = useState({});
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}car?page=${page}`);
        setData(response.data);
        setTotalPages(response.data.totalPages);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [page]);

  const truncateWords = (text, count) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > count
      ? words.slice(0, count).join(" ") + "..."
      : text;
  };

  return (
    <>
      <div className="showroom-area-1 space overflow-hidden">
        <div className="container">
          <div className="row g-4">
            {loading ? (
              Array.from({ length: data?.data?.docs?.length || 6 }).map(
                (_, index) => (
                  <div className="col-12 col-md-6 col-lg-4" key={index}>
                    <div className="showroom-card style-shadow pt-0">
                      <div className="showroom-card_img">
                        <Skeleton height={200} />
                      </div>
                      <div className="showroom-card_content">
                        <h4 className="showroom-card_title h5 mt-2">
                          <Skeleton width={120} height={20} />
                        </h4>
                        <p className="showroom-card_text">
                          <Skeleton width={200} height={15} />
                        </p>
                        <div className="price-box">
                          <p className="me-2">
                            <Skeleton width={80} height={20} />
                            <Skeleton width={60} height={20} />
                          </p>
                          <p>
                            <Skeleton width={80} height={20} />
                            <Skeleton width={60} height={20} />
                          </p>
                        </div>
                        <div className="row g-2 mt-3">
                          {Array.from({ length: 6 }).map((_, i) => (
                            <p className="col-6 mb-0 fw-medium" key={i}>
                              <Skeleton width={100} height={15} />
                            </p>
                          ))}
                        </div>
                        <div className="text-center">
                          <Skeleton width={150} height={40} />
                          <Skeleton width={150} height={40} className="ms-2" />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )
            ) : data?.data?.docs?.length > 0 ? (
              data?.data?.docs?.map((item, index) => (
                <div className="col-12 col-md-6 col-lg-4" key={index}>
                  <div className="showroom-card style-shadow pt-0 mt-5">
                    <div className="showroom-card_img position-relative ">
                      {item.isSold && (
                        <div className="sold-badge position-absolute">Sold</div>
                      )}
                      {item?.featuredImage ? (
                        <div
                          className="position-relative"
                          style={{ height: "400px" }}
                        >
                          {!loadedImages[item._id] && (
                            <Skeleton
                              height={400}
                              width="100%"
                              className="position-absolute top-0 start-0 w-100 h-100"
                            />
                          )}
                          <img
                            src={`${Url}/${item?.featuredImage}`}
                            alt="Featured Car"
                            onLoad={() =>
                              setLoadedImages((prev) => ({
                                ...prev,
                                [item._id]: true,
                              }))
                            }
                            style={{
                              width: "100%",
                              height: "400px",
                              objectFit: "cover",
                              display: loadedImages[item._id]
                                ? "block"
                                : "none",
                            }}
                            className="rounded-lg shadow-lg"
                          />
                        </div>
                      ) : (
                        <div
                          className="d-flex flex-column align-items-center justify-content-center w-100 bg-light rounded"
                          style={{ height: "400px" }}
                        >
                          <LuImageOff className="fs-1 text-muted" />
                          <p className="text-muted mt-2">No Image Available</p>
                        </div>
                      )}
                    </div>
                    <div className="showroom-card_content">
                      <h4
                        className="showroom-card_title h5 mt-2 cursor-pointer"
                        onClick={() => navigate(`/car-details/${item._id}`)}
                      >
                        {truncateWords(item?.title, 4)}
                      </h4>
                      <p className="showroom-card_text">
                        {item?.shortdescription}
                      </p>
                      <div className="price-box justify-content-start ">
                        <p className="btn style2 me-2 d-flex gap-2">
                          <div>Price</div>
                          <div>£{item?.carPrice}</div>
                        </p>
                      </div>
                      <div className="row g-2">
                        <p className="col-6 mb-0 fw-medium">
                          Color: <span>{item?.color}</span>
                        </p>
                        <p className="col-6 mb-0 fw-medium">
                          Year: <span>{item?.modalYear}</span>
                        </p>
                        <p className="col-6 mb-0 fw-medium">
                          Engine: <span>{item?.enginePower}</span>
                        </p>
                        <p className="col-6 mb-0 fw-medium">
                          Mileage: <span>{item?.miles}</span>
                        </p>
                        <p className="col-6 mb-0 fw-medium">
                          Gearbox: <span>{item?.gearTypes}</span>
                        </p>
                        <p className="col-6 mb-0 fw-medium">
                          Fuel: <span>{item?.fuelTypes}</span>
                        </p>
                      </div>
                      {!item.isSold ? (
                        <div className="mt-3">
                          <button
                            onClick={() => {
                              setShow(true);
                              setCarTitle(item?.title);
                            }}
                            className="btn style2 p-3"
                          >
                            Buy Now
                          </button>
                        </div>
                      ) : (
                        <div className="mt-3">
                          <button className="btn style2 p-3">Sold</button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="showroom-card style-shadow pt-0">
                  <div className="showroom-card_img">
                    <img
                      src="https://www.freeiconspng.com/uploads/no-image-icon-15.png"
                      alt="No Car Available"
                      className="img-fluid"
                    />
                  </div>
                  <div className="showroom-card_content text-center">
                    <h4 className="showroom-card_title h5 mt-2">
                      No Cars Available
                    </h4>
                    <p className="showroom-card_text">
                      Please check back later or explore our other categories.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <CarPurchaseModel
        carTitle={carTitle}
        showModal={show}
        setShowModal={setShow}
      />
      {!loading && totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <nav>
            <ul className="pagination">
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  style={{ backgroundColor: "#d74f1c", color: "white" }}
                  onClick={() => setPage((p) => p - 1)}
                >
                  Previous
                </button>
              </li>
              {Array.from({ length: totalPages }).map((_, i) => (
                <li
                  key={i}
                  className={`page-item ${page === i + 1 ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    style={{
                      backgroundColor: page === i + 1 ? "#000" : "transparent",
                      color: page === i + 1 ? "#fff" : "#000",
                      border: "1px solid #000",
                    }}
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}

              <li
                className={`page-item ${page === totalPages ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  style={{ backgroundColor: "#d74f1c", color: "white" }}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};

export default ShowRoomCards;
